// @flow

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { confirmInvitation } from 'actions/syndicate';
import type { ConfirmInvitationFn } from 'actions/syndicate';
import { isAuthenticated } from 'helpers/auth';

type Props = {
  confirmInvitation: ConfirmInvitationFn
};

class ConfirmInvitation extends Component<Props> {
  async componentDidMount() {
    const { confirmInvitation, match, history } = this.props;
    console.log(isAuthenticated());
    if (!isAuthenticated()) {
      return history.push(`/login/${match.params.token}`);
    }

    await confirmInvitation({ token: match.params.token });
    return history.push('/');
  }
  render() {
    return <div>asdf</div>;
  }
}

export default connect(
  null,
  { confirmInvitation }
)(ConfirmInvitation);



// WEBPACK FOOTER //
// ./src/screens/ConfirmInvitation/index.js